import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import { toast } from "react-toastify";

import { callApi } from "../../../ApiHelper/ApiHelper";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import { RoutesLink } from "../../../ApiHelper/RoutesLink";
import { formatAmount, parseAmount } from "../../../utility/CommonFunctions";

import MainHeading from "../../../components/comman/MainHeading";
import CommonTable from "../../../components/comman/CommonTable";
import BgBlurLoader from "../../../components/Loaders/BgBlurLoader";
import ViewDocumentModal from "../../Sites/ViewDocumentModal";

import DocumentIcon from "../../../components/Icons/DocumentIcon";
import ViewIcon from "../../../components/Icons/ViewIcon";

export default function WorkOrderDetail() {
  let { id } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [workOrder, setWorkOrder] = useState({});
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [modal, setModal] = useState(false);
  const toggleModal = () => {
    setModal(!modal);
  };
  const [pageStates, setPageStates] = useState({
    tableLoader: false,
    invoiceList: [],
  });

  useEffect(() => {
    GetWorkOrderDetail();
    GetInvoiceList();
  }, []);

  const GetWorkOrderDetail = () => {
    let options = {
      method: "GET",
    };
    let API = apiUrl?.get_work_order_detail + `?workorderId=${id}`;
    setIsLoading(true);
    callApi(API, options).then((response) => {
      setIsLoading(false);
      if (response?.status === true) {
        setWorkOrder(response?.data);
      } else {
        toast.error(response?.message);
      }
    });
  };

  const handleDocumentClick = (item) => {
    const docUrl = {
      url: item?.url,
    };
    setSelectedDocument(docUrl);
    setModal(true);
  };

  const GetInvoiceList = () => {
    let options = {
      method: "GET",
    };
    let API = apiUrl.get_invoice + "?" + `workorderId=${id}`;
    setPageStates((prev) => ({
      ...prev,
      tableLoader: true,
      CustomerData: {},
    }));
    callApi(API, options).then((response) => {
      setPageStates((prev) => ({
        ...prev,
        tableLoader: false,
      }));
      if (response?.status === true) {
        const newData = response?.data?.invoice?.map((item) => ({
          ...item,
          inDate: moment(item?.invoiceDate).format("DD-MM-YYYY"),
          siteName: item?.workorder?.site?.name,
          taxableAmt: formatAmount(item?.taxableAmount),
          total: formatAmount(item?.totalAmount),
          tdsAmt: formatAmount(item?.tdsAmount),
          gstAmt: formatAmount(item?.totalAmount - item?.taxableAmount || 0),
          recievedAmt: formatAmount(item?.receivedAmount || 0),
          rententionAmt: formatAmount(item?.rententionAmount || 0),
          gstAmount: formatAmount(item?.totalAmount - item?.taxableAmount),
          grossAmount: formatAmount(item?.grossAmount),
          paymentDueAmt: formatAmount(item?.paymentDue),
          DueDays: item?.dueDays,
        }));
        setPageStates((prevStates) => ({
          ...prevStates,
          invoiceList: newData,
        }));
      }
    });
  };

  const HandleView = (data) => {
    navigate(RoutesLink.invoice_detail + `/${data?.id}`);
  };

  const TableHeading = [
    { value: "invoiceNumber", label: "INV NO." },
    { value: "inDate", label: "Invoice Date" },
    { value: "siteName", label: "Site" },
    { value: "DueDays", label: "Due Days" },
    { value: "taxableAmt", label: "Taxable Amount" },
    { value: "gstAmount", label: "GST Amount" },
    { value: "total", label: "Total Amount" },
    { value: "tdsAmt", label: "TDS Amount" },
    { value: "rententionAmt", label: "Retention Amount" },
    { value: "grossAmount", label: "Net Receivable" },
    { value: "recievedAmt", label: "Received Amount" },
    { value: "paymentDueAmt", label: "Payment Due" },
  ];

  const ActionData = [
    {
      label: "view",
      className: "btn btn-link",
      icon: <ViewIcon />,
      title: "view",
      clickHandler: HandleView,
    },
  ];

  const totalItemsCount = workOrder?.workorderitems?.length || 0;

  return (
    <>
      {isLoading && <BgBlurLoader />}
      <div className="content container-fluid pb-5">
        {/* Main Header */}
        <MainHeading title="Work Order Detail" showBackButton={true} />

        {/* Master Summary Card */}
        <div
          className="card border-0 shadow-sm rounded-3 mb-4"
          style={{ background: "#ffffff" }}
        >
          <div className="card-body p-4">
            {/* Top Identity Strip */}
            <div
              className="d-flex align-items-start justify-content-between flex-wrap gap-3 pb-3 border-bottom"
              style={{ borderColor: "#f1f5f9" }}
            >
              <div className="d-flex align-items-center gap-3">
                <div
                  className="d-inline-flex align-items-center justify-content-center rounded-3 p-2.5 flex-shrink-0"
                  style={{
                    background: "#f1f5f9",
                    color: "#334155",
                    width: "48px",
                    height: "48px",
                    fontSize: "20px",
                  }}
                >
                  🏗️
                </div>
                <div>
                  <div className="d-flex align-items-center gap-2 flex-wrap">
                    <h3
                      className="mb-0 fw-bold text-dark"
                      style={{ letterSpacing: "-0.02em", fontSize: "1.35rem" }}
                    >
                      {workOrder?.workOrderNumber || "--"}
                    </h3>
                    <span
                      className="badge rounded-pill px-2.5 py-1 fw-semibold d-inline-flex align-items-center gap-1"
                      style={{
                        fontSize: "12px",
                        background: "#eff6ff",
                        color: "#1d4ed8",
                        border: "1px solid #bfdbfe",
                      }}
                    >
                      <span>📋</span>
                      <span>{workOrder?.title || "Work Order"}</span>
                    </span>
                  </div>
                  <div className="text-secondary small mt-1 d-flex align-items-center gap-2 flex-wrap">
                    <span className="d-inline-flex align-items-center gap-1">
                      <span>📍</span>
                      <span>
                        <strong>Site:</strong> {workOrder?.site?.name || "--"}
                      </span>
                    </span>
                    <span>•</span>
                    <span className="d-inline-flex align-items-center gap-1">
                      <span>🏢</span>
                      <span>
                        <strong>Customer:</strong>{" "}
                        {workOrder?.site?.customer?.name || "--"}
                      </span>
                    </span>
                    <span>•</span>
                    <span className="d-inline-flex align-items-center gap-1">
                      <span>📅</span>
                      <span>
                        <strong>Date:</strong>{" "}
                        {workOrder?.date
                          ? moment(workOrder?.date).format("DD-MM-YYYY")
                          : "--"}
                      </span>
                    </span>
                  </div>
                </div>
              </div>

              {/* Quick Quantitative Stats */}
              <div className="d-flex align-items-center gap-2 flex-wrap">
                <div
                  className="px-3.5 py-2 rounded-2 text-center"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #e2e8f0",
                    minWidth: "115px",
                  }}
                >
                  <div
                    className="text-secondary text-uppercase"
                    style={{
                      fontSize: "10.5px",
                      fontWeight: 700,
                      letterSpacing: "0.05em",
                    }}
                  >
                    Total Order Value
                  </div>
                  <div
                    className="fw-bold text-dark"
                    style={{
                      fontSize: "16px",
                      lineHeight: "1.2",
                      marginTop: "2px",
                    }}
                  >
                    {formatAmount(workOrder?.totalAmount) || "--"}
                  </div>
                </div>

                <div
                  className="px-3.5 py-2 rounded-2 text-center"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #e2e8f0",
                    minWidth: "115px",
                  }}
                >
                  <div
                    className="text-secondary text-uppercase"
                    style={{
                      fontSize: "10.5px",
                      fontWeight: 700,
                      letterSpacing: "0.05em",
                    }}
                  >
                    Taxable Amount
                  </div>
                  <div
                    className="fw-bold text-dark"
                    style={{
                      fontSize: "16px",
                      lineHeight: "1.2",
                      marginTop: "2px",
                    }}
                  >
                    {formatAmount(workOrder?.taxableAmount) || "--"}
                  </div>
                </div>

                <div
                  className="px-3.5 py-2 rounded-2 text-center"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #e2e8f0",
                    minWidth: "85px",
                  }}
                >
                  <div
                    className="text-secondary text-uppercase"
                    style={{
                      fontSize: "10.5px",
                      fontWeight: 700,
                      letterSpacing: "0.05em",
                    }}
                  >
                    Line Items
                  </div>
                  <div
                    className="fw-bold text-dark"
                    style={{
                      fontSize: "16px",
                      lineHeight: "1.2",
                      marginTop: "2px",
                    }}
                  >
                    {totalItemsCount}
                  </div>
                </div>
              </div>
            </div>

            {/* Key Information Grid */}
            <div className="row g-3 pt-3">
              <div className="col-12 col-sm-6 col-lg-3">
                <div
                  className="p-3 rounded-2 h-100"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #f1f5f9",
                  }}
                >
                  <div
                    className="text-muted text-uppercase mb-1"
                    style={{
                      fontSize: "11px",
                      fontWeight: 700,
                      letterSpacing: "0.05em",
                    }}
                  >
                    Site Name
                  </div>
                  <div
                    className="fw-semibold text-dark text-truncate"
                    title={workOrder?.site?.name}
                    style={{ fontSize: "13.5px" }}
                  >
                    {workOrder?.site?.name || "--"}
                  </div>
                  <div
                    className="text-secondary small mt-0.5"
                    style={{ fontSize: "11px" }}
                  >
                    Project Location
                  </div>
                </div>
              </div>

              <div className="col-12 col-sm-6 col-lg-3">
                <div
                  className="p-3 rounded-2 h-100"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #f1f5f9",
                  }}
                >
                  <div
                    className="text-muted text-uppercase mb-1"
                    style={{
                      fontSize: "11px",
                      fontWeight: 700,
                      letterSpacing: "0.05em",
                    }}
                  >
                    Customer
                  </div>
                  <div
                    className="fw-semibold text-dark text-truncate"
                    title={workOrder?.site?.customer?.name}
                    style={{ fontSize: "13.5px" }}
                  >
                    {workOrder?.site?.customer?.name || "--"}
                  </div>
                  <div
                    className="text-secondary small mt-0.5 text-truncate"
                    title={workOrder?.site?.customercompany?.companyName}
                    style={{ fontSize: "11px" }}
                  >
                    {workOrder?.site?.customercompany?.companyName ||
                      "Client Organization"}
                  </div>
                </div>
              </div>

              <div className="col-12 col-sm-6 col-lg-3">
                <div
                  className="p-3 rounded-2 h-100"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #f1f5f9",
                  }}
                >
                  <div
                    className="text-muted text-uppercase mb-1"
                    style={{
                      fontSize: "11px",
                      fontWeight: 700,
                      letterSpacing: "0.05em",
                    }}
                  >
                    GST Type
                  </div>
                  <div
                    className="fw-semibold text-dark"
                    style={{ fontSize: "13.5px" }}
                  >
                    {workOrder?.gstType || "--"}
                  </div>
                  <div
                    className="text-secondary small mt-0.5"
                    style={{ fontSize: "11px" }}
                  >
                    Tax Specification
                  </div>
                </div>
              </div>

              <div className="col-12 col-sm-6 col-lg-3">
                <div
                  className="p-3 rounded-2 h-100"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #f1f5f9",
                  }}
                >
                  <div
                    className="text-muted text-uppercase mb-1"
                    style={{
                      fontSize: "11px",
                      fontWeight: 700,
                      letterSpacing: "0.05em",
                    }}
                  >
                    Payment Terms
                  </div>
                  <div
                    className="fw-semibold text-dark text-truncate"
                    title={workOrder?.paymentTerms}
                    style={{ fontSize: "13.5px" }}
                  >
                    {workOrder?.paymentTerms || "--"}
                  </div>
                  <div
                    className="text-secondary small mt-0.5"
                    style={{ fontSize: "11px" }}
                  >
                    Billing Schedule
                  </div>
                </div>
              </div>

              <div className="col-12 col-sm-6 col-lg-3">
                <div
                  className="p-3 rounded-2 h-100"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #f1f5f9",
                  }}
                >
                  <div
                    className="text-muted text-uppercase mb-1"
                    style={{
                      fontSize: "11px",
                      fontWeight: 700,
                      letterSpacing: "0.05em",
                    }}
                  >
                    Last Billing
                  </div>
                  <div
                    className="fw-semibold text-dark"
                    style={{ fontSize: "13.5px" }}
                  >
                    {workOrder?.lastBillingMonth || "--"}
                  </div>
                  <div
                    className="text-secondary small mt-0.5"
                    style={{ fontSize: "11px" }}
                  >
                    Previous Invoice Cycle
                  </div>
                </div>
              </div>

              <div className="col-12 col-sm-6 col-lg-3">
                <div
                  className="p-3 rounded-2 h-100"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #f1f5f9",
                  }}
                >
                  <div
                    className="text-muted text-uppercase mb-1"
                    style={{
                      fontSize: "11px",
                      fontWeight: 700,
                      letterSpacing: "0.05em",
                    }}
                  >
                    Time Period
                  </div>
                  <div
                    className="fw-semibold text-dark"
                    style={{ fontSize: "13.5px" }}
                  >
                    {workOrder?.startDate
                      ? moment(workOrder.startDate).format("DD MMM YYYY")
                      : "--"}{" "}
                    →{" "}
                    {workOrder?.endDate
                      ? moment(workOrder.endDate).format("DD MMM YYYY")
                      : "--"}
                  </div>
                  <div
                    className="text-secondary small mt-0.5"
                    style={{ fontSize: "11px" }}
                  >
                    Validity Span
                  </div>
                </div>
              </div>

              <div className="col-12 col-sm-6 col-lg-3">
                <div
                  className="p-3 rounded-2 h-100"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #f1f5f9",
                  }}
                >
                  <div
                    className="text-muted text-uppercase mb-1"
                    style={{
                      fontSize: "11px",
                      fontWeight: 700,
                      letterSpacing: "0.05em",
                    }}
                  >
                    Created By
                  </div>
                  <div
                    className="fw-semibold text-dark text-truncate"
                    title={workOrder?.user?.name}
                    style={{ fontSize: "13.5px" }}
                  >
                    {workOrder?.user?.name || "--"}
                  </div>
                  <div
                    className="text-secondary small mt-0.5 text-truncate"
                    style={{ fontSize: "11px" }}
                  >
                    {workOrder?.user?.designation?.name
                      ? `${workOrder?.user?.designation?.name}${
                          workOrder?.user?.department?.name
                            ? ` (${workOrder?.user?.department?.name})`
                            : ""
                        }`
                      : "Order Author"}
                  </div>
                </div>
              </div>

              <div className="col-12 col-sm-6 col-lg-3">
                <div
                  className="p-3 rounded-2 h-100"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #f1f5f9",
                  }}
                >
                  <div
                    className="text-muted text-uppercase mb-1"
                    style={{
                      fontSize: "11px",
                      fontWeight: 700,
                      letterSpacing: "0.05em",
                    }}
                  >
                    Date
                  </div>
                  <div
                    className="fw-semibold text-dark"
                    style={{ fontSize: "13.5px" }}
                  >
                    {workOrder?.date
                      ? moment(workOrder.date).format("DD-MM-YYYY")
                      : "--"}
                  </div>
                  <div
                    className="text-secondary small mt-0.5"
                    style={{ fontSize: "11px" }}
                  >
                    Execution Date
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Work Order Line Items Table Card */}
        <div
          className="card border-0 shadow-sm rounded-3 mb-4 overflow-hidden"
          style={{ background: "#ffffff" }}
        >
          <div
            className="card-header bg-white py-3 px-4 d-flex align-items-center justify-content-between border-bottom"
            style={{ borderColor: "#f1f5f9" }}
          >
            <div className="d-flex align-items-center gap-2">
              <div
                className="rounded-2 p-1.5 d-flex align-items-center justify-content-center"
                style={{ background: "#f1f5f9", color: "#475569" }}
              >
                <span
                  style={{
                    fontSize: "15px",
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    lineHeight: 1,
                  }}
                >
                  🏷️
                </span>
              </div>
              <div>
                <h5
                  className="mb-0 fw-bold text-dark"
                  style={{ fontSize: "15px" }}
                >
                  Work Order Items
                </h5>
              </div>
            </div>
            <span
              className="badge bg-light text-secondary border px-3 py-1.5 rounded-pill"
              style={{ fontSize: "12px", fontWeight: 600 }}
            >
              {totalItemsCount} {totalItemsCount === 1 ? "Item" : "Items"}
            </span>
          </div>

          <div className="table-responsive">
            <table
              className="table pr-detail-table align-middle mb-0"
              style={{ borderCollapse: "separate", borderSpacing: "0" }}
            >
              <thead style={{ background: "#f8fafc" }}>
                <tr>
                  <th
                    style={{
                      width: "50px",
                      padding: "12px 16px",
                      fontSize: "11px",
                      fontWeight: 700,
                      textTransform: "uppercase",
                      letterSpacing: "0.05em",
                      color: "#64748b",
                    }}
                  >
                    #
                  </th>
                  <th
                    style={{
                      minWidth: "200px",
                      padding: "12px 16px",
                      fontSize: "11px",
                      fontWeight: 700,
                      textTransform: "uppercase",
                      letterSpacing: "0.05em",
                      color: "#64748b",
                    }}
                  >
                    Item
                  </th>
                  <th
                    style={{
                      width: "120px",
                      padding: "12px 16px",
                      fontSize: "11px",
                      fontWeight: 700,
                      textTransform: "uppercase",
                      letterSpacing: "0.05em",
                      color: "#64748b",
                    }}
                  >
                    HSN Code
                  </th>
                  <th
                    style={{
                      width: "100px",
                      padding: "12px 16px",
                      fontSize: "11px",
                      fontWeight: 700,
                      textTransform: "uppercase",
                      letterSpacing: "0.05em",
                      color: "#64748b",
                    }}
                  >
                    Quantity
                  </th>
                  <th
                    style={{
                      width: "90px",
                      padding: "12px 16px",
                      fontSize: "11px",
                      fontWeight: 700,
                      textTransform: "uppercase",
                      letterSpacing: "0.05em",
                      color: "#64748b",
                    }}
                  >
                    Unit
                  </th>
                  <th
                    className="text-end"
                    style={{
                      width: "120px",
                      padding: "12px 16px",
                      fontSize: "11px",
                      fontWeight: 700,
                      textTransform: "uppercase",
                      letterSpacing: "0.05em",
                      color: "#64748b",
                    }}
                  >
                    Rate
                  </th>
                  <th
                    className="text-end"
                    style={{
                      width: "130px",
                      padding: "12px 16px",
                      fontSize: "11px",
                      fontWeight: 700,
                      textTransform: "uppercase",
                      letterSpacing: "0.05em",
                      color: "#64748b",
                    }}
                  >
                    Taxable Amount
                  </th>
                  {workOrder?.gstType === "IGST" && (
                    <th
                      className="text-end"
                      style={{
                        width: "140px",
                        padding: "12px 16px",
                        fontSize: "11px",
                        fontWeight: 700,
                        textTransform: "uppercase",
                        letterSpacing: "0.05em",
                        color: "#64748b",
                      }}
                    >
                      IGST
                    </th>
                  )}
                  {workOrder?.gstType === "CGST + SGST" && (
                    <>
                      <th
                        className="text-end"
                        style={{
                          width: "130px",
                          padding: "12px 16px",
                          fontSize: "11px",
                          fontWeight: 700,
                          textTransform: "uppercase",
                          letterSpacing: "0.05em",
                          color: "#64748b",
                        }}
                      >
                        CGST
                      </th>
                      <th
                        className="text-end"
                        style={{
                          width: "130px",
                          padding: "12px 16px",
                          fontSize: "11px",
                          fontWeight: 700,
                          textTransform: "uppercase",
                          letterSpacing: "0.05em",
                          color: "#64748b",
                        }}
                      >
                        SGST
                      </th>
                    </>
                  )}
                  <th
                    className="text-end"
                    style={{
                      width: "150px",
                      padding: "12px 16px",
                      fontSize: "11px",
                      fontWeight: 700,
                      textTransform: "uppercase",
                      letterSpacing: "0.05em",
                      color: "#64748b",
                    }}
                  >
                    Total Amount
                  </th>
                </tr>
              </thead>
              <tbody>
                {workOrder?.workorderitems?.length > 0 ? (
                  [...workOrder?.workorderitems]
                    ?.sort((a, b) => (a?.item || "").localeCompare(b?.item || ""))
                    ?.map((item, index) => {
                      const gstAmount =
                        ((item?.totalAmount || 0) * (item?.gst || 0)) / 100;
                      const halfGst = gstAmount / 2;
                      return (
                        <tr
                          key={item.id || index}
                          style={{ borderBottom: "1px solid #f1f5f9" }}
                        >
                          <td
                            style={{
                              padding: "14px 16px",
                              fontSize: "13px",
                              color: "#94a3b8",
                              fontWeight: 600,
                            }}
                          >
                            {index + 1}
                          </td>
                          <td style={{ padding: "14px 16px" }}>
                            <div
                              className="fw-semibold text-dark"
                              style={{ fontSize: "13.5px" }}
                            >
                              {item?.item || "--"}
                            </div>
                          </td>
                          <td
                            style={{
                              padding: "14px 16px",
                              fontSize: "13px",
                              color: "#475569",
                            }}
                          >
                            {item?.hsnCode || "--"}
                          </td>
                          <td
                            style={{
                              padding: "14px 16px",
                              fontSize: "13.5px",
                              fontWeight: 500,
                              color: "#0f172a",
                            }}
                          >
                            {item?.quantity || "--"}
                          </td>
                          <td style={{ padding: "14px 16px" }}>
                            <span
                              className="badge rounded-pill bg-light text-secondary border px-2 py-0.5"
                              style={{ fontSize: "11.5px" }}
                            >
                              {item?.unit || "--"}
                            </span>
                          </td>
                          <td
                            className="text-end"
                            style={{
                              padding: "14px 16px",
                              fontSize: "13.5px",
                              color: "#475569",
                              fontWeight: 500,
                            }}
                          >
                            {formatAmount(item?.rate)}
                          </td>
                          <td
                            className="text-end"
                            style={{
                              padding: "14px 16px",
                              fontSize: "13.5px",
                              color: "#475569",
                              fontWeight: 500,
                            }}
                          >
                            {formatAmount(item?.totalAmount)}
                          </td>

                          {workOrder?.gstType === "IGST" && (
                            <td
                              className="text-end"
                              style={{
                                padding: "14px 16px",
                                fontSize: "13px",
                                color: "#475569",
                              }}
                            >
                              <div>{formatAmount(gstAmount)}</div>
                              <div
                                className="text-muted"
                                style={{ fontSize: "11px" }}
                              >
                                ({item?.gst || 0}%)
                              </div>
                            </td>
                          )}

                          {workOrder?.gstType === "CGST + SGST" && (
                            <>
                              <td
                                className="text-end"
                                style={{
                                  padding: "14px 16px",
                                  fontSize: "13px",
                                  color: "#475569",
                                }}
                              >
                                <div>{formatAmount(halfGst)}</div>
                                <div
                                  className="text-muted"
                                  style={{ fontSize: "11px" }}
                                >
                                  ({(item?.gst || 0) / 2}%)
                                </div>
                              </td>
                              <td
                                className="text-end"
                                style={{
                                  padding: "14px 16px",
                                  fontSize: "13px",
                                  color: "#475569",
                                }}
                              >
                                <div>{formatAmount(halfGst)}</div>
                                <div
                                  className="text-muted"
                                  style={{ fontSize: "11px" }}
                                >
                                  ({(item?.gst || 0) / 2}%)
                                </div>
                              </td>
                            </>
                          )}

                          <td
                            className="text-end"
                            style={{
                              padding: "14px 16px",
                              fontSize: "13.5px",
                              color: "#0f172a",
                              fontWeight: 700,
                            }}
                          >
                            {formatAmount(item?.taxableAmount)}
                          </td>
                        </tr>
                      );
                    })
                ) : (
                  <tr>
                    <td
                      colSpan={
                        workOrder?.gstType === "CGST + SGST"
                          ? 10
                          : workOrder?.gstType === "IGST"
                          ? 9
                          : 8
                      }
                      className="text-center py-4 text-muted small fw-bold"
                    >
                      No Data Available
                    </td>
                  </tr>
                )}
              </tbody>
              {workOrder?.workorderitems?.length > 0 && (
                <tfoot
                  style={{
                    background: "#f8fafc",
                    borderTop: "2px solid #e2e8f0",
                  }}
                >
                  <tr className="fw-bold">
                    <td
                      style={{
                        padding: "12px 16px",
                        fontSize: "13px",
                        color: "#0f172a",
                      }}
                    >
                      Total
                    </td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td
                      className="text-end"
                      style={{
                        padding: "12px 16px",
                        fontSize: "13.5px",
                        color: "#0f172a",
                      }}
                    >
                      {formatAmount(workOrder?.taxableAmount)}
                    </td>

                    {workOrder?.gstType === "IGST" && (
                      <td
                        className="text-end"
                        style={{
                          padding: "12px 16px",
                          fontSize: "13.5px",
                          color: "#0f172a",
                        }}
                      >
                        {formatAmount(
                          workOrder?.totalAmount - workOrder?.taxableAmount
                        )}
                      </td>
                    )}

                    {workOrder?.gstType === "CGST + SGST" && (
                      <>
                        <td
                          className="text-end"
                          style={{
                            padding: "12px 16px",
                            fontSize: "13.5px",
                            color: "#0f172a",
                          }}
                        >
                          {formatAmount(
                            (workOrder?.totalAmount - workOrder?.taxableAmount) /
                              2
                          )}
                        </td>
                        <td
                          className="text-end"
                          style={{
                            padding: "12px 16px",
                            fontSize: "13.5px",
                            color: "#0f172a",
                          }}
                        >
                          {formatAmount(
                            (workOrder?.totalAmount - workOrder?.taxableAmount) /
                              2
                          )}
                        </td>
                      </>
                    )}

                    <td
                      className="text-end"
                      style={{
                        padding: "12px 16px",
                        fontSize: "13.5px",
                        color: "#0f172a",
                        fontWeight: 700,
                      }}
                    >
                      {formatAmount(workOrder?.totalAmount)}
                    </td>
                  </tr>
                </tfoot>
              )}
            </table>
          </div>
        </div>

        {/* Financial Summary Card */}
        <div
          className="card border-0 shadow-sm rounded-3 mb-4 overflow-hidden"
          style={{ background: "#ffffff" }}
        >
          <div className="card-body p-4">
            <div
              className="d-flex justify-content-between align-items-center flex-wrap gap-3 pb-3 border-bottom"
              style={{ borderColor: "#f1f5f9" }}
            >
              <div className="d-flex align-items-center gap-2">
                <span style={{ fontSize: "18px" }}>💰</span>
                <h5
                  className="mb-0 fw-bold text-dark"
                  style={{ fontSize: "15px" }}
                >
                  Financial Summary
                </h5>
              </div>
              <div>
                <span className="text-secondary small fw-medium">
                  All amounts in INR (₹)
                </span>
              </div>
            </div>

            <div className="row justify-content-end pt-3">
              <div className="col-12 col-md-7 col-lg-5">
                <div className="d-flex flex-column gap-2.5">
                  <div
                    className="d-flex align-items-center justify-content-between p-3 rounded-2"
                    style={{
                      background: "#f8fafc",
                      border: "1px solid #e2e8f0",
                    }}
                  >
                    <span
                      className="text-secondary fw-semibold"
                      style={{ fontSize: "14px" }}
                    >
                      Taxable Amount:
                    </span>
                    <span
                      className="fw-bold text-dark"
                      style={{ fontSize: "15px" }}
                    >
                      {formatAmount(workOrder?.taxableAmount)}
                    </span>
                  </div>

                  <div
                    className="d-flex align-items-center justify-content-between p-3 rounded-2"
                    style={{
                      background: "#f8fafc",
                      border: "1px solid #e2e8f0",
                    }}
                  >
                    <span
                      className="text-secondary fw-semibold"
                      style={{ fontSize: "14px" }}
                    >
                      Total GST:
                    </span>
                    <span
                      className="fw-bold text-dark"
                      style={{ fontSize: "15px" }}
                    >
                      {formatAmount(
                        (workOrder?.totalAmount || 0) -
                          (workOrder?.taxableAmount || 0)
                      )}
                    </span>
                  </div>

                  <div
                    className="d-flex align-items-center justify-content-between p-3 rounded-2 mt-1"
                    style={{
                      background: "#f0fdf4",
                      border: "1px solid #bbf7d0",
                    }}
                  >
                    <div>
                      <div
                        className="text-uppercase"
                        style={{
                          fontSize: "11px",
                          fontWeight: 700,
                          color: "#166534",
                          letterSpacing: "0.04em",
                        }}
                      >
                        Total Order Amount
                      </div>
                      <div
                        className="text-muted"
                        style={{ fontSize: "11.5px" }}
                      >
                        Contract Value including GST
                      </div>
                    </div>
                    <div className="text-end">
                      <span
                        className="fw-bold"
                        style={{ fontSize: "1.35rem", color: "#15803d" }}
                      >
                        {formatAmount(workOrder?.totalAmount)}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Attached Documents & Remarks Section */}
        <div className="row g-4 mb-4">
          {/* Documents Card */}
          <div className="col-12 col-lg-5">
            <div
              className="card border-0 shadow-sm rounded-3 h-100"
              style={{ background: "#ffffff" }}
            >
              <div
                className="card-header bg-white py-3 px-4 d-flex align-items-center justify-content-between border-bottom"
                style={{ borderColor: "#f1f5f9" }}
              >
                <div className="d-flex align-items-center gap-2">
                  <span
                    style={{
                      fontSize: "16px",
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      lineHeight: 1,
                      transform: "translateY(-2px)",
                    }}
                  >
                    📎
                  </span>
                  <h5
                    className="mb-0 fw-bold"
                    style={{ fontSize: "14.5px", color: "#0f172a" }}
                  >
                    Documents
                  </h5>
                </div>
                <span
                  className="badge bg-light text-secondary border px-2.5 py-1 rounded-pill"
                  style={{ fontSize: "11px" }}
                >
                  {workOrder?.documents?.length || 0} Files
                </span>
              </div>
              <div className="card-body p-4">
                {workOrder?.documents && workOrder.documents.length > 0 ? (
                  <div className="d-flex flex-column gap-2">
                    {workOrder.documents.map((doc, index) => (
                      <div
                        key={doc.id || index}
                        role="button"
                        onClick={() => handleDocumentClick(doc)}
                        className="p-3 rounded-2 d-flex align-items-center justify-content-between gap-3 text-decoration-none shadow-sm"
                        style={{
                          background: "#f8fafc",
                          border: "1px solid #e2e8f0",
                          cursor: "pointer",
                          transition: "all 0.2s ease",
                        }}
                      >
                        <div className="d-flex align-items-center gap-2 overflow-hidden">
                          <div
                            className="rounded-2 p-1.5 d-flex align-items-center justify-content-center flex-shrink-0"
                            style={{
                              background: "#eff6ff",
                              color: "#2563eb",
                              width: "36px",
                              height: "36px",
                            }}
                          >
                            <DocumentIcon />
                          </div>
                          <div className="overflow-hidden">
                            <div
                              className="text-dark fw-semibold text-truncate small"
                              title={doc?.name || "Document"}
                            >
                              {doc?.name || "Document"}
                            </div>
                            <div
                              className="text-muted"
                              style={{ fontSize: "11px" }}
                            >
                              {doc?.updatedAt
                                ? moment(doc?.updatedAt).format(
                                    "DD MMM YYYY | h:mm a"
                                  )
                                : "Attached Document"}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div
                    className="text-muted small py-4 text-center"
                    style={{
                      background: "#f8fafc",
                      borderRadius: "8px",
                      border: "1px dashed #cbd5e1",
                    }}
                  >
                    No Document Found
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Remarks Card */}
          <div className="col-12 col-lg-7">
            <div
              className="card border-0 shadow-sm rounded-3 h-100"
              style={{ background: "#ffffff" }}
            >
              <div
                className="card-header bg-white py-3 px-4 d-flex align-items-center gap-2 border-bottom"
                style={{ borderColor: "#f1f5f9" }}
              >
                <span
                  style={{
                    fontSize: "16px",
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    lineHeight: 1,
                    transform: "translateY(-2px)",
                  }}
                >
                  📝
                </span>
                <h5
                  className="mb-0 fw-bold"
                  style={{ fontSize: "14.5px", color: "#0f172a" }}
                >
                  Remarks
                </h5>
              </div>
              <div className="card-body p-4">
                <div
                  className="p-3 rounded-2"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #e2e8f0",
                    minHeight: "100px",
                    fontSize: "13.5px",
                    color: "#334155",
                    whiteSpace: "pre-wrap",
                  }}
                >
                  {workOrder?.remark || "No Remarks Provided..."}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Invoice List Section */}
        <div
          className="card border-0 shadow-sm rounded-3 mb-4 overflow-hidden"
          style={{ background: "#ffffff" }}
        >
          <div
            className="card-header bg-white py-3 px-4 d-flex align-items-center justify-content-between border-bottom"
            style={{ borderColor: "#f1f5f9" }}
          >
            <div className="d-flex align-items-center gap-2">
              <div
                className="rounded-2 p-1.5 d-flex align-items-center justify-content-center"
                style={{ background: "#f1f5f9", color: "#475569" }}
              >
                <span style={{ fontSize: "15px" }}>🧾</span>
              </div>
              <div>
                <h5
                  className="mb-0 fw-bold text-dark"
                  style={{ fontSize: "15px" }}
                >
                  Invoice List
                </h5>
              </div>
            </div>
            <span
              className="badge bg-light text-secondary border px-3 py-1.5 rounded-pill"
              style={{ fontSize: "12px", fontWeight: 600 }}
            >
              {pageStates?.invoiceList?.length || 0} Invoices
            </span>
          </div>

          <div className="card-body p-4">
            {pageStates?.invoiceList?.length > 0 && (
              <div className="row g-3 mb-4">
                {[
                  {
                    label: "Total TDS",
                    value: pageStates.invoiceList.reduce(
                      (a, i) => a + +i.tdsAmount,
                      0
                    ),
                  },
                  {
                    label: "Retention",
                    value: pageStates.invoiceList.reduce(
                      (a, i) => a + +i.rententionAmount,
                      0
                    ),
                  },
                  {
                    label: "Invoice Amount",
                    value: pageStates.invoiceList.reduce(
                      (a, i) => a + +i.totalAmount,
                      0
                    ),
                  },
                  {
                    label: "Received",
                    value: pageStates.invoiceList.reduce(
                      (a, i) => a + +i.receivedAmount,
                      0
                    ),
                  },
                  {
                    label: "Net Receivable",
                    value: pageStates.invoiceList.reduce(
                      (a, i) => a + parseAmount(i.grossAmount),
                      0
                    ),
                  },
                  {
                    label: "Payment Due",
                    value: pageStates.invoiceList.reduce(
                      (a, i) => a + parseAmount(i.paymentDue),
                      0
                    ),
                  },
                ].map((item, index) => (
                  <div key={index} className="col-12 col-sm-6 col-md-4 col-lg-2">
                    <div
                      className="p-3 rounded-2 text-center h-100"
                      style={{
                        background: "#f8fafc",
                        border: "1px solid #e2e8f0",
                      }}
                    >
                      <div
                        className="text-secondary text-uppercase mb-1"
                        style={{
                          fontSize: "10.5px",
                          fontWeight: 700,
                          letterSpacing: "0.04em",
                        }}
                      >
                        {item.label}
                      </div>
                      <div
                        className="fw-bold text-dark text-truncate"
                        style={{ fontSize: "14.5px" }}
                        title={formatAmount(item.value)}
                      >
                        {formatAmount(item.value)}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}

            <CommonTable
              TableHeading={TableHeading}
              TableData={pageStates?.invoiceList}
              ActionData={ActionData}
              isLoading={pageStates?.tableLoader}
            />
          </div>
        </div>
      </div>

      <ViewDocumentModal
        modal={modal}
        toggle={toggleModal}
        selectedDocument={selectedDocument}
      />
    </>
  );
}
